import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    const observeRevealNodes = () => {
      document.querySelectorAll('main .reveal-on-scroll:not(.is-visible)').forEach((node) => {
        observer.observe(node);
      });
    };

    observeRevealNodes();

    const mutationObserver = new MutationObserver(observeRevealNodes);
    const main = document.querySelector('main');
    if (main) {
      mutationObserver.observe(main, { childList: true, subtree: true });
    }

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[#050505] text-[#f0f0f0]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}
